<div id="PG_ReleaseNotes" class="glb_formBGColor glb_paddingBottomMD glb_Font glb_Font col-12">
    <!-- Close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
    <div class="glb_customFlexRow sticky-top">
        <div class="glb_headerBarBGDark glb_customFlexRow col-12 justify-content-end" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start glb_boxedPaddingNarrow align-self-bottom glb_PaddingVerticalZeroOffset">
                <button id="BTN_CloseReleaseNotes" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_modalClose"></fa-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Title -->
    <br>
    <p class="glb_Font glb_Title glb_TitleMobile text-left text-white col-12 glb_paddingLeftXS">
        Add Release Notes
    </p>

    <!-- Internal or Public -->
    <div class="col-12 glb_customFlexRow glb_paddingBottomSM glb_boxedPadding">
        <div class="col-12 glb_customFlexRow glb_FontLabelDisplay glb_FontSizeSummary">
            <div class="col-2 col-lg-2 justify-content-start glb_customFlexRow glb_LabelFontDark">
                Is Internal: </div>
            <div class="col-10 col-lg-10 glb_customFlexRow glb_Font">
                <p-selectButton id="EL_ReleaseNoteTypeID" class="p-customChooseOptionsSM" [options]="ReleaseNoteTypeOptions"
                    [ngModel]="ReleaseNoteType" [multiple]="false" optionLabel="label" optionValue="value" [allowEmpty]="false"
                    (onChange)="ReleaseNoteTypeOption_Click($event)"></p-selectButton>
            </div>
        </div>
    </div>

    <!-- Lenders -->
    <div *ngIf="ReleaseNoteType == false" class="col-12 glb_customFlexRow glb_paddingTopSM ta-parent glb_boxedPadding">
        <div class="col-12 glb_customFlexRow glb_FontLabelDisplay glb_FontSizeSummary ta-firstchild">
            <div class="col-2 col-lg-2 justify-content-start glb_customFlexRow glb_LabelFontDark">
                Select Lender: </div>
            <div class="glb_customFlexRow col-10">
                <div class="col-10">
                    <p-multiSelect #INP_Lenders id="INP_Lenders" [options]="LenderList" [(ngModel)]="SelectedLenders" optionLabel="ControlDisplay"
                        [appendTo]="'body'" [virtualScroll]="true" [virtualScrollItemSize]="40" [filter]="true" [resetFilterOnHide]="true"
                        [showToggleAll]="true" [showClear]="false" [showHeader]="true" [selectedItemsLabel]="'{0} Lenders selected'"
                        placeholder="Click to select lenders to add lender specific release notes" [selectAll]="LenderSelectAll.Value"
                        (onSelectAllChange)="globalFunctions.MultiSelectAll_Toggle($event, LenderSelectAll, LenderList, SelectedLenders, INP_Lenders)"
                        (onChange)="globalFunctions.MultiSelect_Toggle(LenderSelectAll, LenderList, SelectedLenders)"
                        (onPanelShow)="LenderMultiselect_Group(LenderList,SelectedLenders)" fluid="true">
                    </p-multiSelect>
                </div>
            </div>
        </div>
    </div>

    <!-- Release Date-->
    <div class="col-12 glb_customFlexRow glb_paddingTopSM ta-parent glb_boxedPadding">
        <div class="col-12 glb_customFlexRow glb_FontLabelDisplay glb_FontSizeSummary ">
            <div class="col-2 col-lg-2 justify-content-start glb_customFlexRow glb_LabelFontDark">
                Release Date: </div>
            <div class="glb_customFlexRow col-10">
                <div class="glb_floatParent col-10">
                    <p-datepicker id="INP_ReleaseDate" #calendarReleaseDate [(ngModel)]="DTPReleaseDate.JSDate"
                        class="DTPInputGrid DTPInputStyle glb_Font" [showTime]="false" [showSeconds]="false" [maxDate]="DTPMaxDate" [showIcon]="false"
                        [showButtonPanel]="false" [showButtonBar]="true" [inline]="false" [showOtherMonths]="false" [hideOnDateTimeSelect]="false"
                        [touchUI]="false" [dateFormat]="DTPDateFormat" [hourFormat]="12" [appendTo]="'body'" baseZIndex="15000"
                        inputStyleClass="glb_Font" placeholder="Choose a release date">
                        <ng-template pTemplate="footer">
                            <div id="BTN_CloseCalendar" class="glb_customFlexRow justify-content-center">
                                <button class="glb_standardButton glb_skinLightOutline glb_clickableIconButtonStyle glb_BGColorSkin text-white"
                                    (click)="DTP_Close(calendarReleaseDate, DTPReleaseDate)">OK</button>
                            </div>
                        </ng-template>
                    </p-datepicker>
                    <div class="glb_floatTopRightCalendar">
                        <span class="glb_clickableIconButtonStyleNone glb_skinLightOutline" type="button" (click)="calendarReleaseDate.toggle()">
                            <fa-icon [icon]="['fal', 'calendar-clock']" class="fa-md" style="color:black"></fa-icon>
                        </span>
                    </div>
                </div>
                <!-- button to clear content inside the input box, spans a div of its own -->
                <div class="glb_PaddingHorizontalMD col-2" style="padding-top: 2px;">
                    <span>
                        <button tabindex="-1"
                            class="glb_clickableIconButtonStyleGrey glb_clickableIconButtonColorLight glb_clickableIconButtonMD glb_BGColorClear"
                            type="button" matTooltip="Click to Clear" (click)="ClearReleaseDate()">
                            <fa-icon [icon]="['fal', 'eraser']" class="fa-fw glb_fixedSizeIcons"></fa-icon>
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Release Notes-->
    <div class="col-12 glb_customFlexRow glb_paddingTopSM ta-parent glb_boxedPadding">
        <div class="col-12 glb_customFlexRow glb_FontLabelDisplay glb_FontSizeSummary ta-firstchild">
            <div class="col-2 col-lg-2 justify-content-start glb_customFlexRow glb_LabelFontDark">
                Release Note: </div>
            <div class="glb_customFlexRow col-10">
                <div class="col-10">
                    <textarea id="DU_TextAreaNotes" class="glb_textAreaMD glb_Font glb_maxWidth textAreaHeightRegular glb_roundedBorderSM"
                        placeholder="Enter pipe (|) separated  release notes here." rows="5" [(ngModel)]="ReleaseNotes"></textarea>
                </div>
                <div class="col-2 glb_PaddingHorizontalMD align-self-end" style="padding-bottom: 8px;">
                    <span>
                        <button tabindex="-1"
                            class="glb_clickableIconButtonStyleGrey glb_clickableIconButtonColorLight glb_clickableIconButtonMD glb_BGColorClear"
                            matTooltip="Click to Clear" (click)="ClearReleaseNotes()">
                            <fa-icon [icon]="['fal', 'eraser']" class="fa-fw glb_fixedSizeIcons"></fa-icon>
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Buttons -->
    <div class="col-12 glb_customFlexRow glb_paddingTopSM ta-parent glb_boxedPadding">
        <div class="col-12 glb_customFlexRow glb_FontLabelDisplay glb_FontSizeSummary ta-firstchild">
            <div class="col-2 col-lg-2 glb_customFlexRow glb_LabelFontDark">
            </div>
            <div class="glb_customFlexRow col-10">
                <div class="col-10 glb_customFlexRow justify-content-end">
                    <div class="glb_paddingRightXS">
                        <button id="BTN_CancelReleaseNotesID" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                            matTooltip="Cancel" (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                            <span class="glb_Font glb_smallerText">Cancel</span>
                        </button>
                    </div>
                    <div class="glb_paddingLeftXS">
                        <span>
                            <button id="BTN_SaveReleaseNotesID" class="glb_standardButton glb_skinLightOutline btn glb_BGColorSkin text-white"
                                matTooltip="Save Release Note" (click)="SaveReleaseNotes()">
                                <span class="glb_Font glb_smallerText">Save Release Note</span>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>